<script setup lang="ts">
import './customer_cell.scss'

interface Props {
  data: object | string | number,
  cellConfig: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <template v-if="props.data">
    <div class="customer-cell flex gap-3">
      <Avatar
        :label="props.data?.profile_pic ? null : props.data.name[0]"
        :image="props.data?.profile_pic"
        class="border-[#525252] border-[2px] mr-2"
        size="large"
        style="background-color: #ece9fc; color: #2a1261" shape="circle"
      />
      <div class="flex-col">
        <div>{{props.data?.code}}</div>
        <strong>{{props.data?.name}}</strong>
        <div>
          {{props.data?.phone}} <span class="whitespace-nowrap">| {{props.data?.email}}</span>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="customer-cell flex gap-3">
      --
    </div>
  </template>
</template>

<style scoped>

</style>
